import "../../css/Home.css";
import React, { Suspense, useEffect } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../../Component/Navbar.js";
import SEO from "../../Component/Layout.js";

// image
import backgroundPortfolio from "../../img/backgroundReactPortfolio.webp";

// Traduction
import { Loader } from "../../Component/ComponentTraduction.js";
import { withTranslation } from "react-i18next";

import FocusLoop from "../../Component/FocusLoop.js";

const ProjectsWebT = ({ t }) => {
  const { lang = "fr" } = useParams();
  useEffect(() => {
    const anchor = window.location.hash?.substring(1);
    if (anchor) {
      const el = document.getElementById(anchor);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  }, []);
  return (
    <div className="Home-header overflowHidden fontsRegular">
      <SEO
        lang={lang}
        path="/ProjectsWeb"
        title={`${t("WebProjects.Title")} - Arthur BRU`}
        description="Projets web d'Arthur BRU : site associatif, CMS Next.js, dashboard météo Vue.js, page de paiement Stripe, e-commerce PHP. React, TypeScript, MySQL."
        ogTitle="Projets Web - Arthur BRU"
        ogDescription="Projets web en React, Next.js, Vue.js, PHP : site associatif, CMS, page de paiement Stripe, dashboard météo."
        structuredData={`{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "name": "Projets Web - Arthur BRU",
              "url": "https://www.arthur-portfolio.dev/ProjectsWeb",
              "description": "Projets web en React, Next.js, Vue.js, PHP : site associatif, CMS, page de paiement Stripe, dashboard météo.",
              "author": { "@type": "Person", "name": "Arthur BRU" }
            },
            { "@type": "WebSite", "name": "Au fil des images", "description": "Site web pour une association culturelle basée à Tours.", "author": { "@type": "Person", "name": "Arthur BRU" }, "url": "https://www.assoaufildesimages.com" },
            { "@type": "WebSite", "name": "Celtic La Riche Basket", "description": "Site web pour un club de basket.", "author": { "@type": "Person", "name": "Arthur BRU" }, "url": "https://www.celticlarichebasket.fr/" },
            { "@type": "SoftwareApplication", "name": "Meteo Dashboard", "description": "Dashboard météo développé avec Vue.js.", "author": { "@type": "Person", "name": "Arthur BRU" }, "applicationCategory": "WebApplication" },
            { "@type": "SoftwareApplication", "name": "Articles Manager Next.js", "description": "CMS de gestion d'articles développé avec Next.js.", "author": { "@type": "Person", "name": "Arthur BRU" }, "applicationCategory": "WebApplication" },
            { "@type": "SoftwareApplication", "name": "Page de paiement Stripe", "description": "Page de paiement intégrant Stripe.", "author": { "@type": "Person", "name": "Arthur BRU" }, "applicationCategory": "WebApplication" },
            { "@type": "SoftwareApplication", "name": "Eko", "author": { "@type": "Person", "name": "Arthur BRU" }, "applicationCategory": "WebApplication" },
            { "@type": "SoftwareApplication", "name": "B.A Immobilier", "author": { "@type": "Person", "name": "Arthur BRU" }, "applicationCategory": "WebApplication" },
            { "@type": "WebSite", "name": "Portfolio Arthur BRU", "description": "Portfolio personnel développé avec React.", "author": { "@type": "Person", "name": "Arthur BRU" }, "url": "https://www.arthur-portfolio.dev/" }
          ]
        }`}
      />
      <FocusLoop>
        <Navbar tabIndex={15} />
        <div className="traitSeparator" id="blur"></div>
        <div>
          <div className="contactMeFlex align-items-center fixBackBtnUnity">
            <h1 className="fontsBold underline titleUnityPage" id="blur">
              {t("WebProjects.Title")}
            </h1>
          </div>
          <div className="grid-gamejam2">
            <div className="marge-contact-play modernEnvelop" id="blur">
              <div className="sizeIconCPlus flexIMG">
                <h3 className="Home width">Au fil des images</h3>
              </div>
              <div className="flexIMG width">
                <iframe
                  loading="lazy"
                  src="https://www.youtube.com/embed/UXJA-0_h_CY"
                  title="youtubeVideoPresentationAuFilDesImages"
                  frameBorder="0"
                  width="560"
                  height="315"
                  allowFullScreen
                  className="iframeYoutube"
                ></iframe>
              </div>
              <div className="grid-gamejam">
                <p className="text-align-left padding-1vw font-size-large">
                  <p>
                    <span className="colorPurple">
                      {t("VideoGamesProjects.Langage")}
                    </span>{" "}
                    {t("WebProjects.AuFilDesImages.Langage")}
                  </p>
                  <p>
                    <span className="colorPurple">
                      {t("VideoGamesProjects.Duration")}
                    </span>{" "}
                    {t("WebProjects.AuFilDesImages.Duration")}
                  </p>
                  <p>
                    <span className="colorPurple">
                      {t("VideoGamesProjects.Completion")}
                    </span>{" "}
                    {t("WebProjects.AuFilDesImages.Completion")}
                  </p>
                  <p>
                    <span className="colorPurple">
                      {t("VideoGamesProjects.TeamSize")}
                    </span>{" "}
                    {t("WebProjects.AuFilDesImages.TeamSize")}
                  </p>
                  <p>
                    <span className="colorPurple">
                      {t("VideoGamesProjects.Role")}
                    </span>{" "}
                    {t("WebProjects.AuFilDesImages.Role")}
                  </p>
                </p>
                <p className="text-align-left padding-1vw font-size-large">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: t("WebProjects.AuFilDesImages.Description"),
                    }}
                  ></p>
                </p>
              </div>
              <div className="btnDiscoverProject">
                <a
                  href="https://www.assoaufildesimages.com"
                  target="_blank"
                  rel="noreferrer"
                  tabIndex={1}
                >
                  <button className="btnStyleDiscoverProject fontsBold responsive-text-btn">
                    {t("WebProjects.aboutWebsite")}
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div className="grid-gamejam">
            <div className="marge-contact-play modernEnvelop" id="blur">
              <div className="sizeIconCPlus flexIMG">
                <h3 className="Home width">Celtic La Riche Basket</h3>
              </div>
              <div className="flexIMG width">
                <iframe
                  src="https://www.youtube.com/embed/69aCHSjtFrw"
                  title="youtubeVideoPresentationCelticLaRicheBasket"
                  frameBorder="0"
                  width="560"
                  height="315"
                  allowFullScreen
                  className="iframeYoutube"
                ></iframe>
              </div>
              <p className="text-align-left padding-1vw font-size-large">
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Langage")}
                  </span>{" "}
                  {t("WebProjects.CelticLaRicheBasket.Langage")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Duration")}
                  </span>{" "}
                  {t("WebProjects.CelticLaRicheBasket.Duration")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Completion")}
                  </span>{" "}
                  {t("WebProjects.CelticLaRicheBasket.Completion")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.TeamSize")}
                  </span>{" "}
                  {t("WebProjects.CelticLaRicheBasket.TeamSize")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Role")}
                  </span>{" "}
                  {t("WebProjects.CelticLaRicheBasket.Role")}
                </p>
              </p>
              <p className="text-align-left padding-1vw font-size-large">
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("WebProjects.CelticLaRicheBasket.Description"),
                  }}
                ></p>
              </p>
              <div className="btnDiscoverProject">
                <a
                  href="https://github.com/PoloBongo/WebSite-Basket"
                  target="_blank"
                  rel="noreferrer"
                  tabIndex={2}
                  style={{
                    display: "block",
                    opacity: "1",
                    overflow: "hidden",
                    transition: "all 1s ease",
                  }}
                >
                  <button className="btnStyleDiscoverProject fontsBold z-index responsive-text-btn">
                    {t("VideoGamesProjects.viewMoreCode")}
                  </button>
                </a>
                <span className="marge-contact-play"></span>
                <a
                  href="https://www.celticlarichebasket.fr/"
                  target="_blank"
                  rel="noreferrer"
                  tabIndex={3}
                >
                  <button className="btnStyleDiscoverProject fontsBold responsive-text-btn">
                    {t("WebProjects.aboutWebsite")}
                  </button>
                </a>
              </div>
            </div>
            <div className="marge-contact-play modernEnvelop" id="VueJs">
              <div className="sizeIconCPlus flexIMG">
                <h3 className="Home width">Meteo Dashboard</h3>
              </div>
              <div className="flexIMG width">
                <iframe
                  src="https://www.youtube.com/embed/Ybs2jAo-N-I"
                  title="youtubeVideoPresentation"
                  frameBorder="0"
                  width="560"
                  height="315"
                  allowFullScreen
                  className="iframeYoutube"
                ></iframe>
              </div>
              <p className="text-align-left padding-1vw font-size-large">
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Langage")}
                  </span>{" "}
                  {t("WebProjects.MeteoDashboard.Langage")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Duration")}
                  </span>{" "}
                  {t("WebProjects.MeteoDashboard.Duration")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Completion")}
                  </span>{" "}
                  {t("WebProjects.MeteoDashboard.Completion")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.TeamSize")}
                  </span>{" "}
                  {t("WebProjects.MeteoDashboard.TeamSize")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Role")}
                  </span>{" "}
                  {t("WebProjects.MeteoDashboard.Role")}
                </p>
              </p>
              <p className="text-align-left padding-1vw font-size-large">
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("WebProjects.MeteoDashboard.Description"),
                  }}
                ></p>
              </p>
              <div className="btnDiscoverProject">
                <a
                  href="https://github.com/PoloBongo/VueJS_MeteoDashboard"
                  target="_blank"
                  rel="noreferrer"
                  tabIndex={4}
                  style={{
                    display: "block",
                    opacity: "1",
                    overflow: "hidden",
                    transition: "all 1s ease",
                  }}
                >
                  <button className="btnStyleDiscoverProject fontsBold z-index responsive-text-btn">
                    {t("VideoGamesProjects.viewMoreCode")}
                  </button>
                </a>
                <span className="marge-contact-play"></span>
                <a
                  href="https://polobongo.github.io/VueJS_MeteoDashboard/"
                  target="_blank"
                  rel="noreferrer"
                  tabIndex={5}
                >
                  <button className="btnStyleDiscoverProject fontsBold responsive-text-btn">
                    {t("WebProjects.aboutWebsite")}
                  </button>
                </a>
              </div>
            </div>
            <div className="marge-contact-play modernEnvelop" id="NextJs">
              <div className="sizeIconCPlus flexIMG">
                <h3 className="Home width">Articles Manager Next Js</h3>
              </div>
              <div className="flexIMG width">
                <iframe
                  loading="lazy"
                  src="https://www.youtube.com/embed/ozyPAW86O84"
                  title="youtubeVideoPresentationArticlesManager"
                  frameBorder="0"
                  width="560"
                  height="315"
                  allowFullScreen
                  className="iframeYoutube"
                ></iframe>
              </div>
              <p className="text-align-left padding-1vw font-size-large">
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Langage")}
                  </span>{" "}
                  {t("WebProjects.ArticlesManager.Langage")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Duration")}
                  </span>{" "}
                  {t("WebProjects.ArticlesManager.Duration")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Completion")}
                  </span>{" "}
                  {t("WebProjects.ArticlesManager.Completion")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.TeamSize")}
                  </span>{" "}
                  {t("WebProjects.ArticlesManager.TeamSize")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Role")}
                  </span>{" "}
                  {t("WebProjects.ArticlesManager.Role")}
                </p>
              </p>
              <p className="text-align-left padding-1vw font-size-large">
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("WebProjects.ArticlesManager.Description"),
                  }}
                ></p>
              </p>
              <div className="btnDiscoverProject">
                <a
                  href="https://github.com/PoloBongo/NextJs_Articles_Auth_CMS"
                  target="_blank"
                  rel="noreferrer"
                  tabIndex={6}
                  style={{
                    display: "block",
                    opacity: "1",
                    overflow: "hidden",
                    transition: "all 1s ease",
                  }}
                >
                  <button className="btnStyleDiscoverProject fontsBold z-index responsive-text-btn">
                    {t("VideoGamesProjects.viewMoreCode")}
                  </button>
                </a>
                <span className="marge-contact-play"></span>
                <a
                  href="https://next-js-articles-auth-cms-c5vo.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                  tabIndex={7}
                >
                  <button className="btnStyleDiscoverProject fontsBold responsive-text-btn">
                    {t("WebProjects.aboutWebsite")}
                  </button>
                </a>
              </div>
            </div>
            <div className="marge-contact-play modernEnvelop" id="blur">
              <div className="sizeIconCPlus flexIMG">
                <h3 className="Home width">
                  {t("WebProjects.PaymentPage.PaymentPageTitle")}
                </h3>
              </div>
              <div className="flexIMG width" tabIndex={8}>
                <iframe
                  src="https://www.youtube.com/embed/le0FzwEJX_I"
                  title="youtubeVideoPresentationPaymentPage"
                  frameBorder="0"
                  width="560"
                  height="315"
                  allowFullScreen
                  className="iframeYoutube"
                ></iframe>
              </div>
              <p className="text-align-left padding-1vw font-size-large">
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Langage")}
                  </span>{" "}
                  {t("WebProjects.PaymentPage.Langage")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Duration")}
                  </span>{" "}
                  {t("WebProjects.PaymentPage.Duration")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Completion")}
                  </span>{" "}
                  {t("WebProjects.PaymentPage.Completion")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.TeamSize")}
                  </span>{" "}
                  {t("WebProjects.PaymentPage.TeamSize")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Role")}
                  </span>{" "}
                  {t("WebProjects.PaymentPage.Role")}
                </p>
              </p>
              <p className="text-align-left padding-1vw font-size-large">
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("WebProjects.PaymentPage.Description"),
                  }}
                  tabIndex={9}
                ></p>
              </p>
            </div>
            <div className="marge-contact-play modernEnvelop" id="blur">
              <div className="sizeIconCPlus flexIMG">
                <h3 className="Home width">Eko</h3>
              </div>
              <div className="flexIMG width">
                <iframe
                  src="https://www.youtube.com/embed/gKIXjwVwrMg"
                  title="youtubeVideoPresentationEkoProject"
                  frameBorder="0"
                  width="560"
                  height="315"
                  allowFullScreen
                  className="iframeYoutube"
                ></iframe>
              </div>
              <p className="text-align-left padding-1vw font-size-large">
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Langage")}
                  </span>{" "}
                  {t("WebProjects.Eko.Langage")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Duration")}
                  </span>{" "}
                  {t("WebProjects.Eko.Duration")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Completion")}
                  </span>{" "}
                  {t("WebProjects.Eko.Completion")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.TeamSize")}
                  </span>{" "}
                  {t("WebProjects.Eko.TeamSize")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Role")}
                  </span>{" "}
                  {t("WebProjects.Eko.Role")}
                </p>
              </p>
              <p className="text-align-left padding-1vw font-size-large">
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("WebProjects.Eko.Description"),
                  }}
                ></p>
              </p>
              <div className="btnDiscoverProject">
                <a
                  href="https://github.com/PoloBongo/eko-commerce-project"
                  target="_blank"
                  rel="noreferrer"
                  tabIndex={10}
                >
                  <button className="btnStyleDiscoverProject fontsBold z-index responsive-text-btn">
                    {t("VideoGamesProjects.viewMoreCode")}
                  </button>
                </a>
              </div>
            </div>
            <div className="marge-contact-play modernEnvelop" id="blur">
              <div className="sizeIconCPlus flexIMG">
                <h3 className="Home width">B.A Immobilier</h3>
              </div>
              <div className="flexIMG width" tabIndex={11}>
                <iframe
                  src="https://www.youtube.com/embed/mfMnkY3wAvs"
                  title="youtubeVideoPresentationEkoProject"
                  frameBorder="0"
                  width="560"
                  height="315"
                  allowFullScreen
                  className="iframeYoutube"
                ></iframe>
              </div>
              <p className="text-align-left padding-1vw font-size-large">
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Langage")}
                  </span>{" "}
                  {t("WebProjects.BAImmobilier.Langage")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Duration")}
                  </span>{" "}
                  {t("WebProjects.BAImmobilier.Duration")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Completion")}
                  </span>{" "}
                  {t("WebProjects.BAImmobilier.Completion")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.TeamSize")}
                  </span>{" "}
                  {t("WebProjects.BAImmobilier.TeamSize")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Role")}
                  </span>{" "}
                  {t("WebProjects.BAImmobilier.Role")}
                </p>
              </p>
              <p className="text-align-left padding-1vw font-size-large">
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("WebProjects.BAImmobilier.Description"),
                  }}
                  tabIndex={12}
                ></p>
              </p>
            </div>
            <div className="marge-contact-play modernEnvelop" id="blur">
              <div className="sizeIconCPlus flexIMG">
                <h3 className="Home width">Portfolio</h3>
              </div>
              <div className="flexIMG width">
                <img
                  src={backgroundPortfolio}
                  loading="lazy"
                  alt="Protfolio Preview"
                  className="sizeProjectIMG"
                  tabIndex={13}
                ></img>
              </div>
              <p className="text-align-left padding-1vw font-size-large">
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Langage")}
                  </span>{" "}
                  {t("WebProjects.Portfolio.Langage")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Duration")}
                  </span>{" "}
                  {t("WebProjects.Portfolio.Duration")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.Completion")}
                  </span>{" "}
                  {t("WebProjects.Portfolio.Completion")}
                </p>
                <p>
                  <span className="colorPurple">
                    {t("VideoGamesProjects.TeamSize")}
                  </span>{" "}
                  {t("WebProjects.Portfolio.TeamSize")}
                </p>
              </p>
              <p className="text-align-left padding-1vw font-size-large">
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("WebProjects.Portfolio.Description"),
                  }}
                  tabIndex={14}
                ></p>
              </p>
            </div>
          </div>
        </div>
      </FocusLoop>
    </div>
  );
};

const TranslatedHome = withTranslation()(ProjectsWebT);

export default function ProjectsWeb() {
  return (
    <Suspense fallback={<Loader />}>
      <TranslatedHome />
    </Suspense>
  );
}
